import React, { Component } from "react";
import Footer from "../components/footer.component";
import Header from "../components/header.component";
import "../css/page.css";
import dateTimeHelper from "../helpers/date-time.helper";
import reportVisitService from "../reporting-visit/report-visit.service";

export default class MyExperiencePage extends Component {
  componentDidMount() {
    document.title =
      "My experience | David Šimák - A self-taught JAVA/Kotlin developer";
    window.scrollTo(0, 0);
    reportVisitService.report(window.location.pathname, document.title);
  }

  render() {
    const papirflyStartDate = new Date();
    papirflyStartDate.setFullYear(2022);
    papirflyStartDate.setMonth(4);
    papirflyStartDate.setDate(0);
    papirflyStartDate.setHours(0);
    papirflyStartDate.setMinutes(0);
    papirflyStartDate.setSeconds(0);
    papirflyStartDate.setMilliseconds(0);

    return (
      <div>
        <Header lightColor={true} />
        <div className="page_title_container">
          <label class="big_title">My experience</label>
        </div>

        <div class="section">
          <b>
            <h2>Android apps</h2>
          </b>
          <br />
          <ul>
            <li>
              <b>
                {dateTimeHelper.calculateDuration(
                  new Date(2015, 6, 15),
                  new Date()
                )}{" "}
                of experience
              </b>{" "}
              as hobbyist and self-taught learner working on own projects.
            </li>
            <li>
              <b>4 years and 6 months of experience</b> as contractor working
              for one company for their multiple projects.
            </li>
            <li>
              Developing with latest versions of <b>Android</b>, <b>SDKs</b> and{" "}
              <b>Java</b>.
            </li>
            <li>
              Using internal periphery of phone such as camera, location,
              microphone, printers, integrated 2D scanner and others.
            </li>
            <li>
              Communicating with other periphery like printers and other via{" "}
              <b>Wi-Fi</b> or <b>Bluetooth</b>.
            </li>
            <li>
              Working with database <b>SQLite</b> with help of <b>Room</b> or
              connecting them to <b>Firebase Firestore</b>
            </li>
            <li>
              Developing apps communicating with Rest APIs and services from
              Firebase such as Authentication, Cloud Functions
            </li>
            <li>
              Implementing crash logging with <b>Firebase Crashlytics</b> or
              using my custom solution that relies on <b>ACRA</b> and my own{" "}
              <b>Reporting API</b>.
            </li>
          </ul>
          <br />
          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              width: "calc(100% - 80px)",
              margin: "40px",
            }}
          />
          <br />
          <b>
            <h2>Frontend apps</h2>
          </b>
          <br />
          <ul>
            <li>
              <b>
                {dateTimeHelper.calculateDuration(
                  new Date(2017, 6, 1),
                  new Date()
                )}{" "}
                of experience
              </b>{" "}
              as hobbyist and self-taught learner working on own projects.
            </li>
            <li>
              Starting with only HTML, css and JavaScript. Now developing apps
              with framework ReactJS.
            </li>
            <li>
              Building completely independent apps or connecting them to Rest
              API.
            </li>
          </ul>
          <br />
          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              width: "calc(100% - 80px)",
              margin: "40px",
            }}
          />
          <br />
          <b>
            <h2>Backend apps</h2>
          </b>
          <br />
          <ul>
            <li>
              <b>
                {dateTimeHelper.calculateDuration(
                  new Date(2018, 6, 1),
                  new Date()
                )}{" "}
                of experience
              </b>{" "}
              as hobbyist and self-taught learner working on own projects.
            </li>
            <li>
              <b>
                {dateTimeHelper.calculateDuration(
                  new Date(2022, 4, 1),
                  new Date()
                )}{" "}
                of experience
              </b>{" "}
              as full time employee.
            </li>
            <li>
              Currently developing in <b>Spring Boot Framework</b>
            </li>
            <li>
              Developing with newest versions of <b>Java</b> and also{" "}
              <b>Kotlin</b>
            </li>
            <li>Experience with integration of AWS services</li>
            <li>
              In my own projects using <b>Log4j2 with Reporting API</b> as log
              collector and analyzer, health checker of my backends
            </li>
            <li>
              Using <b>PostgreSQL</b> as database but also have experience with{" "}
              <b>MongoDB</b>
            </li>
          </ul>
        </div>
        <hr
          style={{
            backgroundColor: "#BDBDBD",
            height: "1px",
            border: "0px",
            opacity: 1,
          }}
        />
        <div class="section">
          <h1 className="section-title">Where I’ve Worked</h1>
          <hr className="section-title-hr" />
          <br />
          <div id="papirfly">
            <h2>
              <b>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.papirfly.com/"
                >
                  Papirfly
                </a>
              </b>
            </h2>
            <h3>Java/Kotlin developer</h3>
            <p>
              <b>May 2022 - present</b> &bull;{" "}
              {dateTimeHelper.calculateDuration(papirflyStartDate, new Date())}{" "}
              &bull; working full time
              <br />
              <br />
              <ul>
                <li>
                  Developing innovative marketing tools and tools for effective
                  brand management that are used by big companies like Subway,
                  Coca-Cola, Fjällräven, Helly Hansen, Bridgestone and more then
                  500 others world companies
                </li>
                <li>
                  Developing backend applications and libraries with JAVA and
                  Kotlin using Spring Boot, AWS, PostgreSQL, Docker, Kubernetes
                  and other technologies
                </li>
                <li>
                  Modifying frontend applications in Angular and Typescript
                </li>
                <li>
                  Working in multinational team of developers that enable me to
                  gain experience working in large team and also sharpened my
                  skills in English
                </li>
              </ul>
            </p>
          </div>
          <br />
          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              width: "calc(100% - 80px)",
              margin: "40px",
            }}
          />
          <br />
          <div id="elisoft">
            <h2>
              <b>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.elisoft.cz/"
                >
                  Elisoft s.r.o.
                </a>
              </b>
            </h2>
            <h3>Android developer</h3>
            <p>
              <b>July 2017 - February 2018</b> &bull; 8 months &bull; part-time
              internship during high school <br />
              <b>July 2018 - April 2022</b> &bull; 3 years 10 months &bull; full
              time as freelancer <br />
              <br />
              <ul>
                <li>
                  Developing mobile POS application for stores, restaurants etc.
                  with integrated registration of sales (abbreviated as “EET” in
                  Czech) is an advanced system of online communication between
                  entrepreneurs and Financial Authority and also with GASTRO
                  functions for restaurants
                </li>
                <li>
                  Developing mobile PLU scanner for warehouse for stock
                  disbursements, sales, receipts or inventories.
                </li>
                <li> Testing and working with kubernetes cluster</li>
                <li>
                  Making support for mobile apps, helping clients with setting
                  first startup
                </li>
                <li>
                  Communicating with clients with test versions of apps to fix
                  bugs in apps
                </li>
                <li>
                  Creating API backend and authentication in Firebase, Cloud
                  Functions in Google Cloud and Firestore database in Firebase
                </li>
                <li>
                  Getting experience in building commercial products and
                  releasing them to end users
                </li>
              </ul>
            </p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
